import TravelBuddyCover from "../assets/images/travelbuddy-cover.png";
import SmartMoneyCover from "../assets/images/smartmoney-mask.png";
import WindshieldCover from "../assets/images/windshield-cover.png";

// Status labels shown on cards and project pages.
export const STATUS = {
	live: "Live product",
	prototype: "Prototype",
	concept: "Concept",
	experiment: "Experiment",
	archived: "Archived",
};

// Products and experiments I'm building now. Shown first on the Work page
// and the homepage. Only add confirmed entries here; the section is hidden
// while this list is empty.
export const products = [];

// Selected work from my design career. Fields left as null are hidden on
// the site until confirmed.
export const designWork = [
	{
		slug: "travelbuddy",
		name: "TravelBuddy",
		type: "Product Design",
		summary: "A carpooling app concept designed around safety for commuters in Pakistan.",
		users: "Daily commuters in Pakistan",
		date: "2022",
		contribution: "Research, UX and UI design",
		status: STATUS.concept,
		image: TravelBuddyCover,
		imageAlt: "TravelBuddy home screen with a ride search form",
		linkLabel: "Read the case study",
	},
	{
		slug: "smartmoney",
		name: "SmartMoney",
		type: "Product Design",
		summary: "A personal budgeting app for tracking spending and setting monthly limits.",
		users: "People managing their personal spending and monthly budgets",
		date: null,
		contribution: "Product design",
		status: null,
		image: SmartMoneyCover,
		imageAlt:
			"Three SmartMoney screens: spending analysis chart, monthly category budgets, and quick add expense",
		linkLabel: "View the project",
	},
	{
		slug: "windshield-2020",
		name: "Windshield 2020",
		type: "UI Design",
		summary: "A donor management tool for tracking donors, campaigns and follow-ups.",
		users: "Nonprofit fundraising teams",
		date: null,
		contribution: "UI design",
		status: null,
		image: WindshieldCover,
		imageAlt:
			"Windshield 2020 dashboard with donor stats, tasks, campaigns needing attention, and a calendar",
		linkLabel: "View the project",
	},
];

export const allProjects = [...products, ...designWork];

export function getProject(slug) {
	return allProjects.find((project) => project.slug === slug);
}
